import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import { Button, FormControlLabel, Checkbox } from "@mui/material";
import { Refresh } from "@mui/icons-material";

import { initLocalization } from "../../../utils/helpers";
import { spendsRefreshButtonStrings } from "./locale";
import { E_RETAIL_SPENDS_AUTOREFRESH_INTERVAL } from "../../../constants";

export const SpendsRefreshButton = ({ onRefresh }) => {
  initLocalization(spendsRefreshButtonStrings);

  const [autorefresh, setAutorefresh] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(
    E_RETAIL_SPENDS_AUTOREFRESH_INTERVAL,
  );

  useEffect(() => {
    let interval;

    if (autorefresh) {
      interval = setInterval(() => {
        setSecondsLeft((prev) => {
          if (prev <= 1) {
            onRefresh();
            return E_RETAIL_SPENDS_AUTOREFRESH_INTERVAL;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      setSecondsLeft(E_RETAIL_SPENDS_AUTOREFRESH_INTERVAL);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [autorefresh, onRefresh]);

  return (
    <Grid container>
      <Button
        sx={{ ml: 2 }}
        onClick={onRefresh}
        startIcon={<Refresh sx={{ transform: "scaleX(-1)" }} />}
        variant="outlined"
        disabled={autorefresh}
      >
        {spendsRefreshButtonStrings.refresh}
      </Button>
      <FormControlLabel
        control={<Checkbox checked={autorefresh} sx={{ p: 0, pr: 0.5 }} />}
        label={spendsRefreshButtonStrings.formatString(
          spendsRefreshButtonStrings.autorefresh,
          secondsLeft,
        )}
        slotProps={{ typography: { variant: "body2" } }}
        onChange={(e) => setAutorefresh(e.target.checked)}
        sx={{ ml: 2, mr: 0 }}
      />
    </Grid>
  );
};

SpendsRefreshButton.propTypes = {
  onRefresh: PropTypes.func.isRequired,
};
